import ConfirmationAlert from "@/ui/composed/alerts/ConfirmationAlert";
import MultiSelectModalConfig from "@/ui/composed/modal/MultiSelectModal/MultiSelectModalConfig";
import { joinTestIDs } from "@/utils/string.util";

interface MultiSelectModalDismissConfirmationAlertProps extends ViewWithTestID {
  isOpen: boolean;
  onConfirm: () => void;
  onDismiss: () => void;
}

const MultiSelectModalDismissConfirmationAlert = ({
  isOpen,
  onConfirm,
  onDismiss,
  testID,
}: MultiSelectModalDismissConfirmationAlertProps) => {
  return (
    <ConfirmationAlert
      confirmationType="destructive"
      confirmText={MultiSelectModalConfig.DiscardChangesButtonTitle}
      isOpen={isOpen}
      message={MultiSelectModalConfig.DiscardChangesAlertMessage}
      onConfirm={onConfirm}
      onDismiss={onDismiss}
      testID={joinTestIDs(testID, "discard-alert")}
      title={MultiSelectModalConfig.DiscardChangesAlertTitle}
    />
  );
};

export default MultiSelectModalDismissConfirmationAlert;
